import { useEffect, useState } from 'react';

export function useDebounceValue<T>({ value, delay = 150 }: { value: T; delay?: number }) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
